import { ProductMedia, SimpleProduct } from "../models/product/product"

export const getProductImages = (media: ProductMedia[] = [], simple?: SimpleProduct) => {
  if (!simple?.sku) {
    const commonImages = media.filter(image => image.isCommon)
    return commonImages.length ? commonImages : media
  }

  const images = [
    ...media.filter(image => image.filename?.includes(simple.sku) && !image.isCommon),
    ...media.filter(image => image.isCommon)
  ]
  return images.length ? images : media
}
